import owd from 'owd/owd';
import browser from 'owd/utils/browser';

export default class BrowserIE extends owd.Module {
    constructor(app) {
        super(app);
        
        if(browser.isIe()) {
            $('html').addClass('ie');
        }
    }
}